














































































































































































































































































import "./plan.less";
import Vue from "vue";
import Util from "./../../lib/util";
import { mapState, mapGetters } from "vuex";
import { loadStripeCheckout } from "../stripe/load-checkout";
import { countryOptions } from "../stripe/stripe_country_codes";
import BillingAccount from "../../store/entities/billingAccount";
import moment from "moment";
import AppConsts from "../../lib/appconst";

import VueSlider from "vue-slider-component";
import "./vue-slider.scss";

let _: any = require("lodash");
const prefixCls = "wizard";

export default Vue.extend({
  name: "PlanSelector",
  components: { VueSlider },
  props: {
    show: Boolean,
    idPrefix: String,
  },
  data() {
    return {
      quantity: 0,
      lastQuantity: 0,
      showQuantityWarning: false,
      showMoreUsers: false,
      isQuoteRequestSent: false,
      marks: [1, 5, 10, 25, 50, 75, 100],
      marks2: [1, 5, 10, 25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 501],
      isBilledMonthly: false,
      selectedPlan: null,
      preview: null,
      token: null,

      stripe: null,
      elements: null,
      card: null,
      paymentModel: {
        cardholder: null,
        coupon: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        state: null,
        zipCode: null,
        country: null,
      },
      paymentModelRules: {
        cardholder: [
          {
            required: true,
            message: "Please fill in Cardholder",
            trigger: "blur",
          },
        ],
        addressLine1: [
          {
            required: true,
            message: "Please fill in Street Address",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "Please fill in City",
            trigger: "blur",
          },
        ],
        state: [
          {
            required: true,
            message: "Please fill in State / Province",
            trigger: "blur",
          },
        ],
        zipCode: [
          {
            required: true,
            message: "Please fill in Postal Code",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Please fill in Country",
            trigger: "blur",
          },
        ],
      },
      countryOptions: countryOptions,
      currentStep: "select",
      currentStepIndex: 0,
    };
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount", "pricePlans"]),
    showModal: {
      get: function () {
        return (this as any).show;
      },
      set: function () {
        this.$emit("cancel");
      },
    },
    plans() {
      let context = this as any;
      return context.pricePlans && context.pricePlans.length > 0 ? context.pricePlans.filter((p) => p.interval === (context.isBilledMonthly ? "month" : "year")) : [];
    },
    assignedQuantity() {
      let context = this as any;
      return context.billingAccount ? context.billingAccount.members.filter((m) => m.licenseAssigned === true).length : 0;
    },
    isSelectedInList() {
      let context = this as any;
      return context.plans.filter((p) => p === context.selectedPlan).length === 1;
    },
    nextBillDate() {
      return moment(this.preview.invoices.data[0].period_end).format("DD MMM YYYY");
    },
    style() {
      return {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };
    },
    dotsClasses() {
      return [`${prefixCls}-dots`, `${prefixCls}-dots-inside`];
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        let context = this as any;
        context.currentStep = "select";
        context.currentStepIndex = 0;
        context.isQuoteRequestSent = false;
        let plans = context.pricePlans && context.pricePlans.length > 0 ? context.pricePlans.filter((p) => p.priceId === context.billingAccount.currentPlanId) : [];
        context.selectedPlan = plans.length > 0 ? plans[0] : context.pricePlans[0];
        //Monthly only for Beta
        context.isBilledMonthly = true;
        //context.isBilledMonthly = context.selectedPlan && context.selectedPlan.interval === "month" ? true : false;

        context.quantity = context.billingAccount.licenseQuantity;
        context.showMoreUsers = context.quantity > 100;
        context.lastQuantity = context.billingAccount.licenseQuantity;

        this.getPricePlans();
      }
    },
    isBilledMonthly(newValue) {
      let context = this as any;
      let plans =
        context.pricePlans && context.pricePlans.length > 0
          ? context.pricePlans.filter((p) => p.interval === (newValue ? "month" : "year") && (context.selectedPlan ? context.selectedPlan.accountLevel === p.accountLevel : true))
          : [];

      if (plans.length > 0) {
        context.selectPlan(plans[0]);
      }
    },
  },
  mounted() {
    let context = this;
    loadStripeCheckout(AppConsts.stripe_pk, "v3", () => {
      context.stripe = (window as any).Stripe(AppConsts.stripe_pk);
      var elements = context.stripe.elements();
      context.card = elements.create("card", { hidePostalCode: true, style: context.style });
      context.card.mount(`#${context.idPrefix}-payment-card`);
      context.card.addEventListener("change", ({ error }) => {
        const displayError = document.getElementById(`${context.idPrefix}-payment-card-errors`);
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      });
    });
  },
  methods: {
    getPricePlans() {
      if (this.plans.length <= 0) {
        this.$store
          .dispatch("billing/getPricePlans")
          .then((response) => {})
          .finally(() => {});
      }
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs["PaymentForm"] as any).resetFields();
        } catch (error) {}
      }
    },
    getPrice(plan) {
      var tiers = plan.priceTiers.filter((t) => t.quantityUpTo >= this.quantity);
      if (plan.interval === "month") {
        return tiers.length > 0 ? tiers[0].flatCost / 100 : "";
      } else {
        return tiers.length > 0 ? Math.round(tiers[0].flatCost / 100 / 12) : "";
      }
    },
    handlerWizardStep(forward) {
      let steps = ["select", "payment", "confirm"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.currentStep) + (forward ? 1 : -1);
      this.currentStepIndex = nextStepIndex;
      this.currentStep = steps[nextStepIndex];
    },
    selectPlan(plan) {
      if (plan && plan.accountLevel === 1) {
      } else {
        this.selectedPlan = plan;
      }
    },
    getPreview() {
      let context = this as any;
      if (context.selectedPlan && context.isSelectedInList) {
        context.handlerWizardStep(true);
      }
    },
    collectPaymentInfo(event) {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      (this.$refs["PaymentForm"] as any).validate((valid) => {
        if (valid) {
          let context = this as any;
          var options = {
            name: context.paymentModel.cardholder,
            address_line1: context.paymentModel.addressLine1,
            address_city: context.paymentModel.city,
            address_state: context.paymentModel.state,
            address_zip: context.paymentModel.zipCode,
            address_country: context.paymentModel.country,
          };

          if (context.paymentModel.addressLine2) {
            options["address_line2"] = context.paymentModel.addressLine2;
          }

          context.stripe.createToken(context.card, options).then((result) => {
            if (result.token) {
              context.token = result.token;
              context.$store
                .dispatch("billing/updateSubscriptionPreview", {
                  data: {
                    plan: context.selectedPlan.priceId,
                    quantity: context.quantity,
                    coupon: context.paymentModel.coupon,
                    immediately: true,
                  },
                })
                .then((response) => {
                  context.preview = response.data.result;
                  context.handlerWizardStep(true);
                })
                .finally(() => {
                  target.disabled = false;
                });
            } else {
              target.disabled = false;
            }
          });
        } else {
          target.disabled = false;
          return;
        }
      });
    },
    confirm(event) {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this as any;
      var options = {
        name: context.paymentModel.cardholder,
        address_line1: context.paymentModel.addressLine1,
        address_city: context.paymentModel.city,
        address_state: context.paymentModel.state,
        address_zip: context.paymentModel.zipCode,
        address_country: context.paymentModel.country,
      };

      if (context.paymentModel.addressLine2) {
        options["address_line2"] = context.paymentModel.addressLine2;
      }

      context.$store
        .dispatch("billing/updateSubscription", {
          data: {
            plan: context.selectedPlan.priceId,
            quantity: context.quantity,
            token: context.token.id,
            coupon: context.paymentModel.coupon,
            immediately: true,
          },
        })
        .then((response) => {
          if (response.data.result.success === true) {
            context.$Modal.success({
              title: "Congratulations!",
              content: "Your credit card transaction was successful!",
              onOk: () => {
                context.$emit("updated");
                context.$emit("cancel");
              },
            });
          } else {
            context.$Modal.error({
              title: "Oops!",
              content: response.data.result.errorMessage,
              okText: "Retry",
              onOk: () => {
                context.handlerWizardStep(false);
              },
            });
          }
        })
        .finally(() => {
          target.disabled = false;
        });
    },
    getDiscountName(invoice, discountId) {
      return invoice.discount && invoice.discount.id === discountId && invoice.discount.coupon ? invoice.discount.coupon.name : "";
    },
    formatCurrency(number) {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(number);
    },
    requestMoreLicenses(user) {
      this.$store
        .dispatch("billing/requestMoreLicenses", {
          data: {},
        })
        .then((response) => {
          this.isQuoteRequestSent = true;
        })
        .finally(() => {});
    },
    handleQuantityChange(value) {
      if (value < this.assignedQuantity) {
        this.quantity = this.lastQuantity;
        this.showQuantityWarning = true;
      } else {
        //this.showQuantityWarning = this.lastQuantity < this.assignedQuantity;
        this.lastQuantity = value;
        this.showQuantityWarning = false;
      }
    },
  },
});
